export default {
    editPrices: 'provisioningProfile/editPrices',
    delete: 'provisioningProfile/delete',
    add: 'provisioningProfile/add',
    addBulk: 'provisioningProfile/addBulk'
}